// Centralized API configuration
// Update this file when the API URL changes

export const API_CONFIG = {
  BASE_URL: 'https://mythic-api.just-vibes-guild.com/api',
  API_KEY: 'hewwoPwinc3ss',
} as const;

/** Battle.net region for all guild roster characters (realm comes from guild-members per row). */
export const GUILD_REGION = 'us' as const;

export function normalizeRealmSlug(s: string): string {
  return s.trim().toLowerCase().replace(/[\s_]+/g, '-');
}

/**
 * Trust character-profiles data for this guild row only when the profile's realm matches the guild row.
 * If the profile omits realm (legacy), allow. If the guild row has no realm but the profile has one, reject.
 */
export function profileRealmMatchesGuildRow(profileRealm: unknown, guildRealm: string): boolean {
  const hasProfileRealm = typeof profileRealm === 'string' && profileRealm.trim() !== '';
  const hasGuildRealm = typeof guildRealm === 'string' && guildRealm.trim() !== '';
  if (!hasProfileRealm) {
    return true;
  }
  if (!hasGuildRealm) {
    return false;
  }
  return normalizeRealmSlug(profileRealm) === normalizeRealmSlug(guildRealm);
}

/**
 * Guild API `weeks_with_4_plus_runs` (Weeks Met Minimum on roster). Set false only to mask API values during a reset.
 */
export const USE_GUILD_API_WEEKS_MET_COUNTS = true;

export function displayWeeksMetRequirement(apiValue: number): number {
  return USE_GUILD_API_WEEKS_MET_COUNTS ? apiValue : 0;
}

/**
 * GET path for the current Midnight Mythic+ leaderboard (same JSON shape as mythic-rank).
 * Rows must match MYTHIC_MIDNIGHT_CURRENT_SEASON_SLUG; untagged rows are used only when the
 * response root `mythic_season` is that slug.
 */
export const MYTHIC_MIDNIGHT_LEADERBOARD_ENDPOINT = 'mythic-rank';

/** GET mythic raid progression (Voidspire / tier) for the Progress page live banner. */
export const RAID_MYTHIC_PROGRESS_ENDPOINT = 'raid-mythic-progress';

/** Archived Midnight Season 1 slug on mythic-rank / character-profiles. */
export const MYTHIC_MIDNIGHT_S1_SEASON_SLUG = 'season-mn-1';

/** Live Midnight Season 2 slug on mythic-rank / character-profiles. */
export const MYTHIC_MIDNIGHT_CURRENT_SEASON_SLUG = 'season-mn-2';

export function normalizeMythicApiSeasonSlug(v: unknown): string {
  if (v == null || v === '') return '';
  return String(v).toLowerCase().trim().replace(/_/g, '-');
}

export function isMythicSeasonSlug(v: unknown, slug: string): boolean {
  return normalizeMythicApiSeasonSlug(v) === slug;
}

export function isCurrentMidnightSeasonSlug(v: unknown): boolean {
  return isMythicSeasonSlug(v, MYTHIC_MIDNIGHT_CURRENT_SEASON_SLUG);
}

// Helper function to get full API URL
export function getApiUrl(endpoint: string): string {
  // Remove leading slash if present to avoid double slashes
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint.slice(1) : endpoint;
  return `${API_CONFIG.BASE_URL}/${cleanEndpoint}`;
}











